module.exports = __webpack_public_path__ + "media/images/contact-bg-dark-c3db13e0456478c745d7129634976675.svg";